export const exportToTxt = (data, filename = 'chat.txt') => {
    // Create a Blob with the data
    const blob = new Blob([data], { type: 'text/plain;charset=utf-8' });

    // Create a link element
    const link = document.createElement('a');

    // Create a URL for the Blob
    link.href = URL.createObjectURL(blob);
    link.download = filename; // Set the name of the file

    // Programmatically click the link to trigger the download
    document.body.appendChild(link); // Append link to body
    link.click(); // Click the link to download
    document.body.removeChild(link); // Remove the link from the document
}